// extracted by mini-css-extract-plugin
export var icon = "_75-1";
export var subtext = "_75-0";